import React from "react";

import Head from "./components/layouts/Head";
import Sidebar from "./components/layouts/Sidebar";
import { Outlet, useLocation } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { LicenseInfo } from '@mui/x-license';


function App() {

  LicenseInfo.setLicenseKey('02927b6d94aebaf692e82d00d7b6421bTz0xMjUwOTgsRT0xODAxNDM5OTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');

  const location = useLocation();

  const resolveTitle = () => {
    if (location.pathname.startsWith("/portfolio")) {
        return { title: "Portfolio", pathname: location.pathname };
    }
    if (location.pathname.match(/^\/company\/[^/]+/)) {
        // Extract company name from URL
        const companyName = decodeURIComponent(location.pathname.split('/company/')[1].split('/')[0]);
        return { 
            title: companyName, 
            pathname: location.pathname,
            isCompanyPage: true 
        };
    }
    if (location.pathname.startsWith("/activity-reports")) {
        return { title: "Activity Reports", pathname: location.pathname };
    }
    //grade-reports/2/review-report
    if (location.pathname.match(/^\/grade-reports\/[^/]+\/review-report$/)) {
        return { title: `${location.state.companyName}  ${location.state.reportName}`, pathname: location.pathname, statusType: location.state.statusType };
    }
    if (location.pathname.match(/^\/grade-reports\/[^/]+\/request-settings$/)) {
        return { title: "Request Settings", pathname: location.pathname };
    }
    if (location.pathname.match(/^\/grade-reports\/[^/]+$/)) {
      return { title: `${location.state.request_type}, ${location.state.reportName}`, pathname: location.pathname };
    }
    if(location.pathname.match("/create-request/companies")) {
      console.log("location.pathname: ", location.state);
      return { title: ` `, pathname: location.state.settingsData?.report_name || "New Report Request" };
    }
    if(location.pathname.match("/create-request/report")) {
      return { title: ` `, pathname: location.pathname };
    } 
    if (location.pathname.startsWith("/create-request")) {
      return { title: `New Report Request`, pathname: location.pathname };
    } 
    if(location.pathname.startsWith("/shared-requests")) {
      return { title: `Shared Request | ${location.state?.reportName || "Unnamed Request"}`, pathname: location.pathname };
    }
    return "Portfolio";
  };

  return (
    <Grid container sx={{ overflowX: "hidden", width: "100vw" }}>
      <Sidebar />
      <Grid item xs style={{ height: "100vh", width: "calc(100vw - 252px)" }}>
        <Head pathProps={resolveTitle()} />
        <Outlet /> 
        
      </Grid>
    </Grid>
  );
}

export default App;
